import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col space-y-8" }
const _hoisted_2 = {
  key: 0,
  class: "text-3xl md:text-4xl bg-white/10 p-4 text-center rounded-lg"
}

import { computed, ComputedRef, Ref } from "vue";
import Timer from "@/Interfaces/Timer";
import BigTitle from "@/components/Title/BigTitle.vue";
import MediumText from "@/components/Texts/MediumText.vue";
import { useGameStore } from "@/Store/useGameStore";
import { Action } from "@/Interfaces/Action";


export default /*#__PURE__*/_defineComponent({
  __name: 'GameInterface',
  setup(__props) {

const gameStore = useGameStore();

const indexAction: ComputedRef<number> = computed(() => {
  return gameStore.indexAction;
});

const gameActions: ComputedRef<Action[]> = computed(() => {
  return gameStore.gameActions;
});

const timer: Ref<Timer | undefined> = computed(() => {
  return gameStore.timers.find(
    (timer) => timer.action_id === indexAction.value
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BigTitle, {
      title: gameActions.value[indexAction.value].category.name,
      class: "text-center"
    }, null, 8, ["title"]),
    _createVNode(MediumText, {
      text: gameActions.value[indexAction.value].description
    }, null, 8, ["text"]),
    (timer.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_unref(gameStore).secondsToMinutesAndSeconds(timer.value.time_left)), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})